<template>
    <div class="component-course-box">
        <router-link :to="'/' + $route.params.lang + '/course/' + fields.moduleNumber" class="picture">
            <img :src="require
            ('@/assets/module-' + fields.moduleNumber + '/' + $route.params.lang + '/module-thumb.jpg')" :alt="fields.moduleTitle" :title="fields.moduleTitle" />
        </router-link>
        <div class="desc">
            <h2>
                <router-link :to="'/' + $route.params.lang + '/course/' + fields.moduleNumber">
                    <span>MODULE {{ fields.moduleNumber }}</span>
                    {{ fields.moduleTitle }}
                </router-link>
            </h2>
            <router-link :to="'/' + $route.params.lang + '/course/' + fields.moduleNumber" class="btn readmore">{{ $PPlusEngine.getDictionary($route.params.lang, 'เข้าคอร์ส', 'Attend') }}</router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fields: Object
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.component-course-box {
    margin-top: 30px;
    background: #fff;

    .picture {
        display: block;

        img {
            display: block;
            width: 100%;
        }
    }

    .desc {
        padding: 15px;
        border-top: 2px solid #e2b7a3;
        text-align: center;

        h2 {
            font-size: 16px;
            line-height: 24px;
            margin: 0 0 20px;

            a {
                display: block;
                color: #333;
                height: 93px;
                overflow: hidden;

                &:hover {
                    text-decoration: none;
                    opacity: 0.5;
                }

                span {
                    display: block;
                    font-size: 12px;
                    padding-bottom: 15px;
                    color: $mainColor;

                    &:after {
                        content: " ";
                        display: block;
                        width: 42px;
                        height: 1px;
                        background: $mainColor;
                        margin: 5px auto 0;
                    }
                }
            }
        }

        .readmore {
            @include borderRadius(0);
            padding: 6px 18px;
            font-size: 15px;
            color: #fff;
            border: 1px solid #8a8383;
            background: #8a8383;
        }
    }
}
</style>